import React from 'react';
import {Col, Row} from 'antd';
import InputFormField from '../../components/data_entry/form/InputFormField';
import SelectFormField from '../../components/data_entry/form/SelectFormField';
import {STATE_OPTIONS} from '../../constants/constants';
import {FIELD_NAMES} from './constants';

export default function AddressSection() {
    return (
        <>
            <Row gutter={16}>
                <Col xs={24} sm={12} lg={8}>
                    <InputFormField
                        form={{
                            label: 'CEP',
                            name: FIELD_NAMES.POSTAL_CODE,
                            rules: [{required: true, message: 'Campo obrigatório'}],
                        }}
                        placeholder="00000-000"
                    />
                </Col>
                <Col xs={24} sm={12} lg={16}>
                    <InputFormField
                        form={{
                            label: 'Rua',
                            name: FIELD_NAMES.STREET,
                            rules: [{required: true, message: 'Campo obrigatório'}],
                        }}
                        placeholder="Nome da rua"
                    />
                </Col>

                <Col xs={24} sm={12} lg={8}>
                    <InputFormField
                        form={{
                            label: 'Número',
                            name: FIELD_NAMES.NUMBER,
                            rules: [{required: true, message: 'Campo obrigatório'}],
                        }}
                        placeholder="Número"
                    />
                </Col>
                <Col xs={24} sm={12} lg={16}>
                    <InputFormField
                        form={{
                            label: 'Bairro',
                            name: FIELD_NAMES.NEIGHBORHOOD,
                            rules: [{required: true, message: 'Campo obrigatório'}],
                        }}
                        placeholder="Bairro"
                    />
                </Col>

                <Col xs={24} sm={12} lg={8}>
                    <InputFormField
                        form={{
                            label: 'Cidade',
                            name: FIELD_NAMES.CITY,
                            rules: [{required: true, message: 'Campo obrigatório'}],
                        }}
                        placeholder="Cidade"
                    />
                </Col>
                <Col xs={24} sm={12} lg={8}>
                    <SelectFormField
                        form={{
                            label: 'Estado',
                            name: FIELD_NAMES.STATE,
                            rules: [{required: true, message: 'Campo obrigatório'}],
                        }}
                        options={STATE_OPTIONS.map((uf) => ({label: uf, value: uf}))}
                        placeholder="Selecione o estado"
                        showSearch
                    />
                </Col>
            </Row>
            <InputFormField
                form={{
                    label: 'Complemento',
                    name: FIELD_NAMES.COMPLEMENT,
                }}
                placeholder="Complemento (opcional)"
            />
        </>
    );
}
